import { CommonModule } from '@angular/common';
import { Component, DestroyRef, OnInit, inject } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { ReadService } from '@common/service/read.service';
import { AuthDelegationService } from '@core/auth/auth-delegation.service';
import { NgbDropdownModule } from '@ng-bootstrap/ng-bootstrap';
import { DelegationInfo, DelegationState } from '@shared/model/delegation.model';
import { AuthService } from '../../../core/auth/auth.service';

@Component({
  standalone: true,
  selector: 'app-delegation-dropdown',
  templateUrl: './delegation-dropdown.component.html',
  styleUrls: ['./delegation-dropdown.component.scss'],
  imports: [CommonModule, NgbDropdownModule],
})
export class DelegationDropdownComponent implements OnInit {
  isAuthenticated = false;
  currentDelegation: DelegationState | null = null;
  availableDelegations: DelegationInfo[] = [];
  readService = inject(ReadService);
  delegationService = inject(AuthDelegationService);

  private readonly destroy: DestroyRef = inject(DestroyRef);

  constructor(private authService: AuthService) {}

  ngOnInit() {
    this.currentDelegation = this.delegationService.getDelegationState();
    this.subscribeToAuthState();
  }

  private subscribeToAuthState() {
    this.authService
      .getProfile()
      .pipe(takeUntilDestroyed(this.destroy))
      .subscribe((profile) => {
        this.isAuthenticated = !!profile;

        if (this.isAuthenticated) {
          this.currentDelegation = this.delegationService.getDelegationState();
          if (!this.currentDelegation) {
            this.loadAvailableDelegations();
          }
        }
      });
  }

  private loadAvailableDelegations() {
    if (!this.isAuthenticated) return;

    this.readService
      .query('ListUserDelegation', { params: {} })
      // this.authService.getAvailableDelegations()
      .subscribe({
        next: (delegations) => {
          this.availableDelegations = delegations;
        },
        error: (error) => {
          this.availableDelegations = [];
        },
      });
  }

  // Component actions
  switchToDelegation(delegation: DelegationInfo) {
    if (delegation.delegationId === this.currentDelegation?.delegationId) {
      return; // Already using this delegation
    }

    this.authService.switchToDelegation(delegation.delegationId).subscribe({
      next: (response) => {
        console.log('Successfully switched to delegation:', response.delegatorName);
      },
      error: (error) => {
        console.error('Failed to switch to delegation:', error);
        alert('Failed to switch user. Please try again.');
      },
    });
  }

  switchBackToOriginal() {
    this.authService.clearDelegationState();
  }
}
